<script lang="ts">
    export let playerClick: (e: Event) => void = undefined;
    export let showProgressBar: boolean = false;
    export let realm: 'music' | 'podcasts' | 'classical' = 'music';
</script>

<div class="mini-player" class:mini-player-with-progress={showProgressBar}>
    <div data-testid="mini-player" class="mini-player__body">
        {#if playerClick}
            <button
                class="mini-player__metadata mini-player__metadata-button"
                data-testid="mini-player-metadata"
                on:click={playerClick}
            >
                <slot name="mini-player-artwork" />
                <slot name="mini-player-text" />
            </button>
        {:else}
            <div
                class="mini-player__metadata"
                data-testid="mini-player-metadata"
            >
                <slot name="mini-player-artwork" />
                <slot name="mini-player-text" />
            </div>
        {/if}
        <div class="mini-player__controls" data-testid="mini-player-controls">
            <amp-playback-controls-play />
            {#if realm === 'podcasts'}
                <amp-playback-controls-skip
                    direction="forward"
                    fallbackSeconds={30}
                />
            {:else}
                <amp-playback-controls-item-skip direction="next" />
            {/if}
        </div>
    </div>
    {#if showProgressBar}
        <div class="mini-player__progress" data-testid="mini-player-progress">
            <amp-playback-controls-progress-range class="lcd__progress" />
        </div>
    {/if}
</div>

<style lang="scss">
    .mini-player {
        display: grid;
        grid-template-columns: repeat(4, 0) 1fr;
        grid-template-rows: var(--miniPlayerHeight) 0 repeat(2, 0);
        grid-column-gap: 0;
        grid-row-gap: 0;
        border-radius: 14px;
        background-color: var(--miniPlayerBackground);
        backdrop-filter: saturate(60%) blur(20px);
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
        margin: 0 12px;
        overflow: hidden;
    }

    .mini-player-with-progress {
        grid-template-rows: calc(var(--miniPlayerHeight) - 3px) 0 3px repeat(
                2,
                0
            );
    }

    .mini-player__body {
        $mini-player-gutter: 12px;
        --playback-controls-play-color: var(
            --miniPlayerPlayButtonColor,
            --systemPrimary
        );
        --skip-control-color: var(--miniPlayerPlayButtonColor, --systemPrimary);
        --playback-control-icon-width: var(
            --miniPlayerControlsButtonWidth,
            35px
        );
        --playback-control-icon-height: var(
            --miniPlayerControlsButtonWidth,
            35px
        );
        --skip-icon-width: var(--miniPlayerControlsButtonWidth, 35px);
        --skip-icon-height: var(--miniPlayerControlsButtonWidth, 35px);
        grid-area: 1 / 5 / 2 / 6;
        width: var(--miniPlayerWidth, calc(100vw - #{$mini-player-gutter * 2}));
        max-width: calc(760px - #{$mini-player-gutter * 2});
        height: var(--miniPlayerHeight, 56px);
        display: flex;
        gap: 11px;
        align-items: center;
        margin-inline-start: var(--miniPlayerMarginStart, $mini-player-gutter);
        padding-inline-start: var(--miniPlayerPaddingStart, 8px);
        padding-inline-end: var(--miniPlayerPaddingEnd, 15px);

        amp-playback-controls-play {
            width: var(--miniPlayerControlsButtonWidth, 41px);
            margin-inline-end: 9px;
        }

        amp-playback-controls-skip {
            --playback-control-icon-width: 25px;
            --playback-control-icon-height: 25px;
        }
    }

    .mini-player__metadata {
        display: flex;
        width: 100%;
        min-width: 0;
        align-items: center;
        background-color: transparent;
    }

    .mini-player__metadata-button {
        cursor: pointer;
    }

    .mini-player__controls {
        display: flex;
    }

    amp-playback-controls-item-skip {
        --skip-control-color-hover: var(--systemPrimary);
    }

    .mini-player__progress {
        grid-area: 3 / 5 / 4 / 6;
    }

    amp-playback-controls-progress-range {
        --progress-track-color: var(--miniPlayerLCDProgressTrackColor);
        --progress-track-color-elapsed: var(
            --miniPlayerLCDProgressTrackColorElapsed
        );
        --progress-thumb-color: transparent;
    }
</style>
